import request from '@/utils/request'

const rootPath = 'summary'

export function fetch(path, query) {
  return request({
    url: `${rootPath}/${path}`,
    method: 'get',
    params: query
  })
}
